/**
 * Constants and configuration for popup custom module
 * @module popup-custom/constants
 */

/**
 * localStorage key used by the location redirect popup
 * @constant {string}
 */
export const LOCATION_STORAGE_KEY = 'location_redirect_choice';

/**
 * Custom event dispatched by the location redirect popup when a confirmed choice is saved
 * @constant {string}
 */
export const LOCATION_CHOICE_EVENT = 'location-redirect-choice-saved';

/**
 * Delay (ms) before showing popup after the location redirect choice is made
 * @constant {number}
 */
export const DEFERRED_SHOW_DELAY = 500;

/**
 * DOM selectors for popup elements
 * @constant {Object}
 */
export const SELECTORS = {
  configPrefix: '[id^="popup-custom-config-"]',
  closeBtn: '.popup-custom__close',
};

/**
 * CSS classes used by the location redirect popup
 * @constant {Object}
 */
export const CLASSES = {
  visible: 'is-visible',
};

/**
 * Selector for focusable elements (used for focus trapping)
 * @constant {string}
 */
export const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
